
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import moment from 'moment';

export class GenApiKey {

    id: number;
    createdAt: moment.Moment;
    description: string;
    enabled: boolean;
    expiresAt: moment.Moment;
    key: string;
    lastUsedAt: moment.Moment;
    supportedSystems: string[];
    userId: number;

    constructor();
    constructor( jsonObj: any );
    constructor( genApiKey: GenApiKey);
    constructor( id: number );

    constructor( input?: GenApiKey|number ) {
        if ( typeof input === 'number') {
            this.id = input;
        }

        if ( input && typeof input !== 'number' ) {
            this.id = input.id; // int [number]
            if ( input.createdAt && typeof input.createdAt === 'string' ) {
                this.createdAt = moment(input.createdAt).utc();
            } else {
                this.createdAt = input.createdAt;
            }
            this.description = input.description; // string [string]
            this.enabled = input.enabled; // boolean [boolean]
            if ( input.expiresAt && typeof input.expiresAt === 'string' ) {
                this.expiresAt = moment(input.expiresAt).utc();
            } else {
                this.expiresAt = input.expiresAt;
            }
            this.key = input.key; // string [string]
            if ( input.lastUsedAt && typeof input.lastUsedAt === 'string' ) {
                this.lastUsedAt = moment(input.lastUsedAt).utc();
            } else {
                this.lastUsedAt = input.lastUsedAt;
            }
            this.supportedSystems = input.supportedSystems; // list [string]
            this.userId = input.userId; // int [number]
       }
    }

    static jsonResponseToList(arr: any[]): GenApiKey[] {
        if (arr && arr.map) {
          return arr.map(a => new GenApiKey(a));
        } else {
          return [];
        }
    }
}

